// Componenet imports
import Layout from '../components/layout'
import MainTitle from '../components/main_title'

import { auth, db } from '../firebase'
import { getDoc, doc } from 'firebase/firestore'
import { useState, useEffect } from 'react'
import { User } from 'firebase/auth'

function Home() {
  const user = auth.currentUser as User
  const [name, setName] = useState(user.uid)

  useEffect(() => {
    const fetchName = async () => {
      const docRef = doc(db, 'Users', user.uid)
      const docSnap = await getDoc(docRef)

      if (docSnap.exists()) {
        console.log(JSON.stringify(docSnap.data()))
        setName(docSnap.data().name)
      }
    }
    fetchName()
  }, [user.uid])

  return (
    <Layout>
      <MainTitle title={`Welcome ${name}!`} />
      <img className="my-5 rounded-sm" src="/img/tenplanets.png" alt="Logos" />
      <div className="mt-12 flex justify-center">
        <div className="btn inline-block transform bg-secondary text-white transition duration-300 ease-out hover:scale-125 hover:bg-opacity-50 hover:shadow-inner">
          Load more
        </div>
      </div>
    </Layout>
  )
}

export default Home
